import {
  useIsDesktop,
  useIsDesktopLarge,
  useIsMobile,
  useIsTablet,
} from '../../../../../hooks';

const MOBILE_HEIGHT = {
  minHeight: '166px',
  maxHeight: '166px',
  editorHeight: '166px',
};

const TABLET_HEIGHT = {
  minHeight: '352px',
  maxHeight: '352px',
  editorHeight: '352px',
};

const DESKTOP_HEIGHT = {
  minHeight: '402px',
  maxHeight: '516px',
  editorHeight: '657px',
};

const DESKTOP_LARGE_HEIGHT = {
  minHeight: '402px',
  maxHeight: '516px',
  editorHeight: '657px',
};

export const useHeight = () => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const isDesktop = useIsDesktop();
  const isDesktopLarge = useIsDesktopLarge();

  if (isDesktopLarge) return DESKTOP_LARGE_HEIGHT;
  if (isDesktop) return DESKTOP_HEIGHT;
  if (isTablet) return TABLET_HEIGHT;
  if (isMobile) return MOBILE_HEIGHT;

  return DESKTOP_LARGE_HEIGHT;
};
